import React from 'react';
import { TypographyMuted } from '@/Components/shadcn';
import { RHFInput } from '@/Components/shadcn/rhf-input';
import { jobsBaseUrl } from '@/AppSettings';
import UIStrings from '@/Utils/UIStrings';
import ProfileGroupForm from './ProfileGroupForm';

function SubdomainSection(): React.JSX.Element {
    return (
        <ProfileGroupForm
            dataCy="SubdomainSection"
            title={UIStrings.SubdomainAsterisk}
            description={UIStrings.YouCanUseLettersNumberAndDashes}
        >
            <div className="flex h-auto w-full max-w-md flex-row items-start">
                <TypographyMuted className="mt-2.75 mr-2 flex-shrink-0 whitespace-nowrap">
                    {`${new URL(jobsBaseUrl).hostname}/`}
                </TypographyMuted>
                <RHFInput className="min-w-0 flex-1" id="companySlug" name="companySlug" type="text" />
            </div>
        </ProfileGroupForm>
    );
}

export default SubdomainSection;
